import dayjs from 'dayjs'

export const formatCallBackDatetime = (date: string, time: string) => {
  return dayjs
    .tz(`${date} ${time}`)
    .set('second', 0)
    .set('millisecond', 0)
    .utc()
    .format('YYYY-MM-DDTHH:mm:ss[Z]')
}

